import { Reducer } from 'redux';
import { SegmentationsState, SegmentationsTypes } from './types';

export const INITIAL_STATE: SegmentationsState = {
  segmentations: [],
  segmentationData: {
    id: '',
    name: '',
    title: '',
    description: '',
    estimation: 0,
    data: [],
    createdAt: '',
    updatedAt: '',
  },
  segmentationValues: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<SegmentationsState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST SEGMENTATIONS
    case SegmentationsTypes.LIST_SEGMENTATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        segmentations: INITIAL_STATE.segmentations,
      };
    case SegmentationsTypes.LIST_SEGMENTATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        segmentations: action.payload.segmentations,
        totalCount: action.payload.totalCount,
      };
    case SegmentationsTypes.LIST_SEGMENTATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        segmentations: INITIAL_STATE.segmentations,
      };

    // LIST SEGMENTATIONS VALUES
    case SegmentationsTypes.LIST_SEGMENTATION_VALUES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        segmentationValues: INITIAL_STATE.segmentationValues,
      };
    case SegmentationsTypes.LIST_SEGMENTATION_VALUES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        segmentationValues: action.payload.segmentationValues,
      };
    case SegmentationsTypes.LIST_SEGMENTATION_VALUES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        segmentationValues: INITIAL_STATE.segmentationValues,
      };

    // GET SEGMENTATION
    case SegmentationsTypes.GET_SEGMENTATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        segmentationData: INITIAL_STATE.segmentationData,
      };
    case SegmentationsTypes.GET_SEGMENTATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        segmentationData: action.payload.segmentationData,
      };
    case SegmentationsTypes.GET_SEGMENTATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        segmentationData: INITIAL_STATE.segmentationData,
      };

    // CREATE SEGMENTATION
    case SegmentationsTypes.CREATE_SEGMENTATION_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.CREATE_SEGMENTATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.CREATE_SEGMENTATION_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE SEGMENTATION
    case SegmentationsTypes.UPDATE_SEGMENTATION_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.UPDATE_SEGMENTATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.UPDATE_SEGMENTATION_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE SEGMENTATION
    case SegmentationsTypes.DELETE_SEGMENTATION_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.DELETE_SEGMENTATION_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.DELETE_SEGMENTATION_FAILURE:
      return { ...state, loading: false, error: true };

    // CREATE SEGMENTATIONS
    case SegmentationsTypes.CREATE_SEGMENTATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.CREATE_SEGMENTATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.CREATE_SEGMENTATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE SEGMENTATIONS
    case SegmentationsTypes.UPDATE_SEGMENTATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.UPDATE_SEGMENTATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.UPDATE_SEGMENTATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE SEGMENTATIONS
    case SegmentationsTypes.DELETE_SEGMENTATIONS_REQUEST:
      return { ...state, loading: true, error: false };
    case SegmentationsTypes.DELETE_SEGMENTATIONS_SUCCESS:
      return { ...state, loading: false, error: false };
    case SegmentationsTypes.DELETE_SEGMENTATIONS_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
